import { useState } from 'react'
import SectionHeader from './SectionHeader'
import { useScrollAnimation } from '../hooks/useScrollAnimation'

const faqs = [
  {
    q: 'Is my brokerage login stored on your servers?',
    a: "No. We use SnapTrade's OAuth integration, which means we only ever receive read-only tokens. Your brokerage login credentials stay between you and your broker — we never see or store them.",
  },
  {
    q: 'How is dividend data sourced?',
    a: 'All dividend data, ex-dates, and pricing are sourced from Financial Modeling Prep (FMP), one of the most trusted financial data providers. Data is updated in real-time during market hours.',
  },
  {
    q: 'Can I track Canadian or international stocks?',
    a: 'Yes! We support dividend stocks, ETFs, and REITs from major exchanges worldwide, including NYSE, NASDAQ, TSX, and LSE. Currency conversion is handled automatically.',
  },
  {
    q: 'What happens to my data if I cancel?',
    a: "Your data is permanently deleted from our servers within 30 days of cancellation. We don't retain or re-sell any of your financial information. You can also export your data as CSV before leaving.",
  },
  {
    q: 'Is Safe Dividend Tracker really free?',
    a: 'Yes. The Free plan is free forever — no credit card, no trial, no expiry. You can upgrade to Premium or Pro at any time to unlock advanced features like brokerage sync, smart alerts, and the options tracker.',
  },
  {
    q: 'Does this work on mobile?',
    a: 'Yes, the entire platform is fully responsive and works great on mobile browsers. Native iOS and Android apps are also in development.',
  },
  {
    q: 'Does Safe Dividend Tracker support two-factor auth (2FA)?',
    a: 'Absolutely. We support TOTP-based 2FA via authenticator apps like Google Authenticator and Authy. We strongly recommend enabling it for additional security.',
  },
]

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null)
  const ref = useScrollAnimation()

  return (
    <section className="bg-[#F8FAFC] section-padding" id="faq">
      <div className="content-max">
        <SectionHeader
          overline="FAQs"
          headline="Frequently asked questions"
        />

        <div ref={ref} className="mt-12 max-w-narrow mx-auto">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border-b border-border-custom"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between py-5 text-left group"
              >
                <span className="text-base font-medium text-[#0F172A] pr-8 group-hover:text-[#1B5E20] transition-colors">
                  {faq.q}
                </span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className={`shrink-0 text-[#1B5E20] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}
                >
                  <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div
                className="overflow-hidden transition-all duration-400 ease-out"
                style={{
                  maxHeight: openIndex === i ? '200px' : '0',
                  opacity: openIndex === i ? 1 : 0,
                }}
              >
                <p className="text-sm text-slate leading-relaxed pb-5">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
